var performanceUtils = {
    timeOrigin: performance.timeOrigin || Date.now() - performance.now(),
};
export var isPerformanceObserverSupported = function () {
    return 'PerformanceObserver' in window && typeof PerformanceObserver === 'function';
};
export default performanceUtils;
